export const TASK_ORIGINS = [
  {
    value: 'corrective',
    label: 'Corrective',
    color: '#be185d',
    bg: '#fce7f3',
    description: 'Created from a remedial to fix a problem that was found',
  },
  {
    value: 'obligation',
    label: 'Obligation',
    color: '#0e7490',
    bg: '#e6f7f9',
    description: 'Carried out to keep a compliance obligation met',
  },
  {
    value: 'standard',
    label: 'User-Defined',
    color: '#64748b',
    bg: '#eef2f6',
    description: 'Work someone scheduled themselves, not raised by a remedial or an obligation',
  },
]

export const originMeta = value => TASK_ORIGINS.find(o => o.value === value) || null

export const taskOriginOf = task => {
  if (task?.origin) return task.origin
  const meta = task?.metadata || {}
  if (meta.source === 'action' || meta.source === 'action_complete' || meta.actionId || meta.action_id) return 'corrective'
  if (task?.complianceObligation || meta.programmeObligationId || meta.programme_obligation_id) return 'obligation'
  return 'standard'
}

export const originLabel = value => originMeta(value)?.label || 'All task types'
